"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M15 4.5a3.75 3.75 0 1 1 5.25 5.25v6.75c0 .413-.337.75-.75.75h-2.317l-.495 4.575a.753.753 0 0 1-.698.668c-.36.022-.72-.045-.9-.39L12.3 17.25H3a.752.752 0 0 1-.75-.75V5.25c0-.412.337-.75.75-.75h12Zm3 4.875a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM14.325 6H3.75v9.758h8.63c.298-.001.61-.002.842.202.068.06.12.127.173.203.061.088.114.185.164.278l.054.097c.08.14.153.28.226.42l.111.21a428.14 428.14 0 0 1 1.455 2.722s.285-2.895.308-3.075l.011-.117c.022-.23.043-.456.191-.648.233-.3.593-.3.938-.3h1.897v-5.325A3.75 3.75 0 0 1 14.325 6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.946 8.624c-.216-.013-.39-.187-.387-.389l.021-1.866-.405.447c-.15.165-.398.16-.554-.013a.465.465 0 0 1-.012-.611L17.688 5l.005-.006a.383.383 0 0 1 .051-.047.369.369 0 0 1 .503.06.48.48 0 0 1 .013.014l1.12 1.236a.465.465 0 0 1 .011.61c-.15.166-.398.16-.554-.012l-.472-.521-.023 1.948c-.002.202-.18.355-.396.341Z"
  })]
});